var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table_headers"
  }, [_c('p', {
    staticClass: "header_indent_sm"
  }, [_vm._v(" ID "), _c('Tooltip', {
    attrs: {
      "content": "Unique identifier for this transaction"
    }
  })], 1), _c('p', [_vm._v(" Chain "), _c('Tooltip', {
    attrs: {
      "content": "Blockchain for this transaction"
    }
  })], 1), _c('p', {
    staticClass: "header_indent"
  }, [_vm._v(" From "), _c('Tooltip', {
    attrs: {
      "content": "Sender address"
    }
  })], 1), _c('p', {
    staticClass: "header_indent"
  }, [_vm._v(" To "), _c('Tooltip', {
    attrs: {
      "content": "Receiver address"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }